import { makeAutoObservable } from "mobx";
import {
    deleteObj,
    getObjById,
    searchByPage,
    saveOrUpdateObj
} from 'app/services/InterestRatePeriodService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { checkSearchObject } from "app/common/LocalFunction";

const defaultValue = {
    code: "",
    name: "",
    amountFrom: 0,
    amountTo: 0,
    periodMonths: 0,
    interestRate: 0,
    isActive: true,
    orderNumber: 0
}

export default class InterestRatePeriodStore {
    searchObj = new SearchObject();
    pageObj = null;
    selectedObj = defaultValue;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    selectedRowObj = [];

    constructor() {
        makeAutoObservable(this);
    }

    setSelectedRowObj = (rows) => {
        this.selectedRowObj = rows;
    };

    pagingObj = async () => {
        return await searchByPage(this.searchObj)
            .then(({ data }) => {
                this.pageObj = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu kỳ hạn lãi suất có lỗi")
            })
    }

    handleChangeFormSearch = (searchObj) => {
        this.searchObj = checkSearchObject(this.searchObj, searchObj);
        this.pagingObj();
    }

    handleOpenFormCreateOrEdit = (id) => {
        if (Boolean(id)) {
            getObjById(id).then(({ data }) => {
                this.selectedObj = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedObj = { ...defaultValue };
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateObj = (dto, { setSubmitting }) => {
        saveOrUpdateObj(dto)
            .then(() => {
                toast.success("Lưu thông tin thành công!");
                this.handleClosePopup();
                this.pagingObj();
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu thông tin có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (id) => {
        this.selectedObj = { id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteObj(this.selectedObj?.id)
            .then(() => {
                if (this.searchObj?.pageIndex > 1 && this.pageObj?.content?.length === 1) {
                    this.searchObj.pageIndex -= 1;
                }
                toast.success("Xóa kỳ hạn lãi suất thành công!");
                this.handleClosePopup();
                this.pagingObj();
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa kỳ hạn lãi suất có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchObj = new SearchObject();
        this.pageObj = null;
        this.selectedObj = defaultValue;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
        this.selectedRowObj = [];
    }

    resetStorePopup = () => {
        this.searchObj = new SearchObject();
        this.pageObj = null;
        this.selectedRowObj = [];
    }
}
